import Parser, {Element, type HTMLReactParserOptions} from 'html-react-parser';
import React from 'react';
import {useDownscaledImageSrc} from 'src/shared/hooks/useDownscaledImageSrc';
import {fixRichTextTokens} from 'src/shared/utils/imageHandler';

interface RichTextImageProps {
  src: string;
  alt?: string;
  width?: string;
}

// Rich text stores the raw <img>; cap it to the container and render the
// print-friendly downscaled source instead of the original file.
const RichTextImage: React.FC<RichTextImageProps> = ({src, alt, width}) => {
  const displaySrc = useDownscaledImageSrc(src);
  return (
    <img
      src={displaySrc}
      alt={alt ?? ''}
      style={{
        maxWidth: '100%',
        height: 'auto',
        width: width ? `${parseInt(width, 10)}px` : undefined,
      }}
    />
  );
};

const options: HTMLReactParserOptions = {
  replace: node => {
    if (node instanceof Element && node.name === 'img' && node.attribs.src) {
      return (
        <RichTextImage
          src={node.attribs.src}
          alt={node.attribs.alt}
          width={node.attribs.width}
        />
      );
    }
    return undefined;
  },
};

export const parseRichText = (html: string, accessToken?: string) =>
  Parser(fixRichTextTokens(html, accessToken), options);
